import { Button, Input, message, Table, Col, Row, Checkbox, DatePicker, Select, Card, Typography, Spin } from "antd";
import dayjs from "dayjs";
import { useEffect, useRef, useState} from "react";
import { serverFetch } from "../../server";
import { tableRenderDate } from "../../extensions/table-render";
import { renderStatusIcon, getTableColumn, dateVids, salesStatuses, productVids } from "../../extensions/helper";
import FreezeModal from "../clients/client-freeze-abon-modal";
import ActivateModal from "../clients/client-activate-abon-modal";
import CloseModal from "../clients/client-close-abon-modal";
import { dictsGetUsers } from "../../extensions/dicts"
import { AddFilter, FilterItem, ResultModal, HoverIcon, SportTooltip } from "../../controls";
import Sale from "./sale";
import "./sales.css";
import { BtnSettingsTable, tblGetColumns } from "../../controls/table-settings.js/table-settings";
import TriStateCheckbox from "../../controls/tri-state-checkbox";
import { exportExcel } from "../../extensions/export-excel";
import Client from "../clients/client";
import { ExportExcelButton, HelpButton, PrintButton } from "../../extensions/design";
import { isMobile, menuSize } from '@extensions/design';
import SalesFilter from "./sales-filter";
import { fmtDate } from "@/extensions/utils";
import { getStatusColor } from "../../extensions/helper";
import { useLocalStorageFilter, applyDateRoll } from "@/extensions/use-local-storage-filter";
const { Text } = Typography;


const tableName = "sales";
const Sales = () => {
  const [items, setItems] = useState([]);
  const [filteredItems, setFilteredItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const [recorded, setRecorded] = useState();
  const [singleModeActive, setSingleModeActive] = useState(false);
  const [freezeModalVisible, setFreezeModalVisible] = useState(false);
  const [activateModalVisible, setActivateModalVisible] = useState(false);
  const [closeModalVisible, setCloseModalVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalResults, setModalResults] = useState([]);
  const [changeModalVisible, setChangeModalVisible] = useState(false);
  const [addingFilter, setAddingFilter] = useState(true);

  // Инициализация фильтра из localStorage или значения по умолчанию
  const [filter, setFilter] = useLocalStorageFilter(
    'salesFilter',
    () => ({
      DateVid: 0,
      DateBeg: dayjs(),
      DateEnd: dayjs(),
      paid: null,
      searchText: '',
    }),
    (parsed) => {
      const { dateFrom, dateTo } = applyDateRoll(
        parsed.DateEnd ? dayjs(parsed.DateEnd) : null,
        dayjs(),
        dayjs(),
        parsed.DateBeg ? dayjs(parsed.DateBeg) : null,
      );
      return {
        DateVid: parsed.DateVid ?? 0,
        DateBeg: typeof dateFrom === 'string' ? dayjs(dateFrom) : dateFrom,
        DateEnd: typeof dateTo === 'string' ? dayjs(dateTo) : dateTo,
        paid: parsed.paid ?? null,
        newClient: parsed.newClient ?? null,
        deleted: parsed.deleted ?? null,
        blocked: parsed.blocked ?? null,
        searchText: parsed.searchText || '',
        ...(parsed.Statuses ? { Statuses: { value: parsed.Statuses.value, inputType: "multiselect" } } : {}),
        ...(parsed.UserIds ? { UserIds: { value: parsed.UserIds.value, inputType: "multiselect" } } : {}),
        ...(parsed.AuthorIds ? { AuthorIds: { value: parsed.AuthorIds.value, inputType: "multiselect" } } : {}),
        ...(parsed.ManagerIds ? { ManagerIds: { value: parsed.ManagerIds.value, inputType: "multiselect" } } : {}),
        ...(parsed.ProductVids ? { ProductVids: { value: parsed.ProductVids.value, inputType: "multiselect" } } : {}),
      };
    },
    (filter) => ({
      DateVid: filter.DateVid,
      DateBeg: filter.DateBeg?.format('YYYY-MM-DD'),
      DateEnd: filter.DateEnd?.format('YYYY-MM-DD'),
      paid: filter.paid,
      newClient: filter.newClient ?? null,
      deleted: filter.deleted ?? null,
      blocked: filter.blocked ?? null,
      searchText: filter.searchText || '',
      ...(filter.Statuses ? { Statuses: { value: filter.Statuses.value } } : {}),
      ...(filter.UserIds ? { UserIds: { value: filter.UserIds.value } } : {}),
      ...(filter.AuthorIds ? { AuthorIds: { value: filter.AuthorIds.value } } : {}),
      ...(filter.ManagerIds ? { ManagerIds: { value: filter.ManagerIds.value } } : {}),
      ...(filter.ProductVids ? { ProductVids: { value: filter.ProductVids.value } } : {}),
    }),
  );
  const [userOptions, setUserOptions] = useState([]);
  const statusOptions = salesStatuses.filter((s) => s.value !== 4);
  const productVidOptions = productVids;
  const divRef = useRef(null);
  const [tableKey, setTableKey] = useState(0);
  const [isPrinting, setIsPrinting] = useState(false);
  const defaultHidden = ["price", "qty", "authorName", "discountPrc", "paid", "totalCalc"];
  const onTableSettingsChange = () => setTableKey(prev => prev + 1);
  const [isClientCard, setIsClientCard] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  
  useEffect(() => {
    dictsGetUsers(setUserOptions);
  }, []);

  const filterOptions = [
    { type: "Statuses", label: "Статус", tooltip: "Статус абонемента", inputType: "multiselect", options: statusOptions },
    { type: "UserIds", label: "Исполнитель", tooltip: "Исполнитель услуги", inputType: "multiselect", options: userOptions },
    { type: "AuthorIds", label: "Пользователь", tooltip: "Автор продажи", inputType: "multiselect", options: userOptions },
    { type: "ManagerIds", label: "Менеджер", tooltip: "Менеджер клиента", inputType: "multiselect", options: userOptions },
    { type: "ProductVids", label: "Вид продажи", tooltip: "Вид номенклатуры в продаже", inputType: "multiselect", options: productVidOptions },
  ];

  const dateFilterOptions = [
    { label: "Дата", value: 0 },
    { label: "Активация", value: 1 },
    { label: "Окончание", value: 2 },
  ]

  const filterLabels = {
    Statuses: "Статус",
    UserIds: "Исполнитель",
    AuthorIds: "Пользователь",
    ManagerIds: "Менеджер",
    ProductVids: "Вид продажи",
  };

  const getData = () => {
    setLoading(true);
    setItems([]);
    setFilteredItems([]);
    console.log(filter)
    const params = new URLSearchParams();
    params.append("DateVid", filter.DateVid ?? 0);
    params.append("DateBeg", filter.DateBeg ? dayjs(filter.DateBeg).format("YYYY-MM-DD") : "");
    params.append("DateEnd", filter.DateEnd ? dayjs(filter.DateEnd).format("YYYY-MM-DD") : "");
    if (filter.newClient != null) params.append("newClient", filter.newClient ? true : false);
    if (filter.deleted != null) params.append("deleted", filter.deleted ? true : false);
    if (filter.blocked != null) params.append("blocked", filter.blocked ? true : false);
    if (filter.paid != null) params.append("paid", filter.paid ? true : false);

    const paramMap = {
      Statuses: "Statuses",
      UserIds: "UserIds",
      AuthorIds: "AuthorIds",
      ManagerIds: "ManagerIds",
      ProductVids: "ProductVids",
    };

    Object.keys(paramMap).forEach(key => {
      const field = filter[key];
      if (!field || !field.value) return;
      const values = Array.isArray(field.value) ? field.value : [field.value];
      values.forEach(v => params.append(paramMap[key], v));
    });

    serverFetch(`Sale/List?${params.toString()}`)
      .then(data => {
        setItems(data)
        console.log(data)
        onSearchChange({ searchText: filter.searchText }, data);
      } )
      .catch(e => message.error(e.userMessage))
      .finally(() => setLoading(false));
  };

  useEffect(getData, [filter]);

  const headerSize = divRef.current?.querySelector('.ant-table-thead')?.offsetHeight ?? 0;
  const tableHeight = divRef.current
    ? (document.documentElement.offsetHeight - headerSize - divRef.current.getBoundingClientRect().top - window.scrollY)
    : 0;
  const tableWidth = (document.documentElement.offsetWidth - divRef.current?.getBoundingClientRect().left) ?? 0;

  const columns = [
      {title: (
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          {!singleModeActive ? (
            <Checkbox checked={selected.length > 0 && selected.length === items.length} indeterminate={selected.length > 0 && selected.length < items.length} onChange={(e) =>
                setSelected(e.target.checked ? items.map((item) => item.id) : [])}
            />
          ) : (
            <div style={{ width: 16 }}/>
          )}
          #
        </div>
      ), dataIndex: "id", key: "id", width: 70,
      render: (id, record) => {
        if (!singleModeActive) {
          return (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <Checkbox
                checked={selected.includes(record.id)}
                onChange={(e) => {
                  setSelected(prev => {
                    const next = e.target.checked ? [...prev, record.id] : prev.filter(x => x !== record.id);

                    if (next.length === 1) {
                      const rec = items.find(x => x.id === next[0]);
                      setRecorded(rec);
                    }

                    return next;
                  });
                }}
                onClick={(e) => e.stopPropagation()}
              />
              {id}
            </div>
          );
        } else {
          const checked = selected.includes(record.id);
          return (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <div className={checked ? "list-indicator" : ""} style={{ marginLeft: 4, marginRight: 4, width: 8 }}/>{id}
            </div>
          );
        }
      },
    },
    getTableColumn("status", "Статус", { render: renderStatusIcon, width: 80 }),
    getTableColumn("isNew", <SportTooltip mouseLeaveDelay={0} title="Первая продажа клиенту" style={{ width:"100%" }}>
      <img src="/images/star.svg" className="table-header-img"/>
      </SportTooltip>, { width: 30,  render: (value) => (<Checkbox style={{ width: 30 }} alt="Новый" checked={value}/>) }),
    getTableColumn("docDate", "Дата", { render: tableRenderDate, width: 85, isSorter: true }),
    getTableColumn("productName", "Товар / услуга", { width: 130 }),
    getTableColumn("qty", "Кол.", { width: 70, isSorter: true, type: "number" }),
    getTableColumn("price", "Цена", { width: 75, isSorter: true, type: "number" }),
    getTableColumn("totalCalc", "Сумма", { 
      width: 100, 
      render: (value, record) => ((record.qty || 0) * (record.price || 0)).toFixed(2),
      isSorter: true,
      type: "number"
    }),
    getTableColumn("discountPrc", "Скидка %", { width: 110, isSorter: true }),
    getTableColumn("syma", "Итого", { width: 85, isSorter: true, type: "number" }),
    /* getTableColumn("paymentDate", "Дата опл", { render: tableRenderDate }), */
    /* getTableColumn("paymentVidName", "Касса"), */
    /* getTableColumn("visitId", "Визит #", { width: 100 }), */
    getTableColumn("clientName", "Клиент", { width: 110, isSorter: true }),
    getTableColumn("managerName", "Менеджер", { width: 100 }),
    getTableColumn("userName", "Исполнитель", { width: 130 }),
    getTableColumn("activation", "Активация", { width: 120, render: tableRenderDate, isSorter: true }),
    getTableColumn("finish", "Окончание", { width: 120, render: tableRenderDate, isSorter: true }),
    getTableColumn("paid", "Оплачено", { width: 110, isSorter: true, type: "number" }),
    getTableColumn("debet", "Долг", { width: 80, isSorter: true, type: "number" }),
    getTableColumn("authorName", "Пользователь", { width: 130 }),
    /* getTableColumn("createdOn", "Продажа", { render: tableRenderDateTime, width: 150 }), */
  ];

  const onFilterChange = (changed) => {
    setFilter((prev) => ({ ...prev, ...changed }));
    uncheckAll();
  };

  const onSearchChange = (changed, sourceItems = items) => {
    const text = changed.searchText.toLowerCase();
    if (!text) {
      setFilteredItems(sourceItems);
      return;
    }

    const searchableFields = [
      "clientName",
      "managerName",
      "userName",
      "productName",
    ];

    const filtered = sourceItems.filter((item) =>
      String(item.id).includes(text) ||
      searchableFields.some((field) => {
        const val = item[field];
        return val && String(val).toLowerCase().includes(text);
      })
    );

    setFilteredItems(filtered);
  };

  const getUniqueOptions = (field) => {
    const unique = Array.from(new Set(items.map(item => item[field]).filter(Boolean)));
    return unique.map(value => ({ label: value, value }));
  };

  const handleAddTopFilter = (type) => {
    if (filter[type]) return; // фильтр уже существует

    const option = filterOptions.find(opt => opt.type === type);
    const inputType = option?.inputType;

    let initialValue = undefined;
    let options = undefined;

   if (inputType === "date") {
      const now = dayjs();
      initialValue = [now.startOf("month"), now.endOf("month")];
    }

    if (inputType === "multiselect") {
      switch (type) {
        case "Statuses": options = statusOptions; break;
        case "ProductVids": options = productVidOptions; break;
        case "UserIds":
        case "AuthorIds":
        case "ManagerIds": options = userOptions; break;
        default: options = getUniqueOptions(type);
      }
    }
    onFilterChange({ [type]: { value: [], inputType: "multiselect", options } });
    setAddingFilter(false);
  };
  
  const onClose = (statusValue, payload) => {
    setFreezeModalVisible(false);
    setActivateModalVisible(false);
    setCloseModalVisible(false);

    if (statusValue) {
      const idSet = new Set(payload.map((x) => String(x.saleId ?? x)));
      setSelected((prev) => prev.filter((id) => idSet.has(String(id))));

      if (payload.length > 0) {
        setModalResults(payload);
        setModalVisible(true);
      } else {
        message.success("Операция выполнена успешно");
        getData();
      }
    }
  };

  const isAllSelected = selected.length > 0 && selected.length === items.length;
  const isNoneSelected = selected.length === 0;

  const checkAll = () => {
    const allIds = items.map((item) => item.id);
    setSelected(allIds);
  };

  const uncheckAll = () => {
    setSelected([]);
  };

  const handleClient = () => {
    setIsClientCard(true)
  };

  const onCloseEdit = (refresh) => {
    setIsClientCard(null);
    refresh && getData();
  };

  const resClose = () => setModalVisible(false)

  const removeTopFilter = (type) => {
    const { [type]: _, ...rest } = filter;
    setFilter(rest);
  };

  const renderFilterItem = (key, data) => {
    const option = filterOptions.find(f => f.type === key);
    const resolvedOptions = option?.options || [];
    
    return (
      <FilterItem
        key={key}
        type={option?.inputType || data.inputType}
        label={filterLabels[key] || key}
        value={data.value}
        options={resolvedOptions}
        onChange={(val) => onFilterChange({ [key]: { ...data, value: val } })}
        onRemove={() => removeTopFilter(key)}
        width={"100%"}
      />
    );
  };

  const filters = Object.entries(filter)
    .filter(([key, data]) => !["DateVid", "DateBeg", "DateEnd", "newClient", "deleted", "blocked", "paid", "searchText"].includes(key))
    .map(([type, data]) => ({ type, ...data }));

  const hasInvalidProductVid = selected.some((id) => {
    const item = items.find((x) => x.id === id);
    return item?.productVid === 0 || item?.productVid === 1;
  });
    
  const handleRowClick = (record) => {
    if (selected.length > 0) {      
      setSelected((prev) =>
        prev.includes(record.id)
          ? prev.filter((id) => id !== record.id)
          : [...prev, record.id]
      );
    } else {
      setSelected([record.id]);
      /* setRecorded(record) */
      setSingleModeActive(true);
      setChangeModalVisible(true);
      setModalResults([record]);
    }
  };

  const handleChangeModalClose = () => {
    setChangeModalVisible(false);
    setSingleModeActive(false);
    setSelected([]);
    getData();
  };
  
  const handlePrint = () => {
    setIsPrinting(true);
    setTimeout(() => {
      window.print();
      setIsPrinting(false);
    }, 500);
  };

  const handleExportExcel = () => {
    exportExcel(items, columns, "Продажи.xlsx");
  };
    
  return !isMobile ? (
    <div className="col-one-main">
      <div className="col-one-title">
        <Col span={5}>
          <Input placeholder="Введите наименование, ФИО, номер продажи" className="search-str" value={filter.searchText} onChange={(e) => onFilterChange({ searchText: e.target.value })}/>
        </Col>
        <Select className="date-select" name="DateVid" options={dateVids} value={filter.DateVid} onChange={(val) => onFilterChange({ DateVid: val })}/>
        <DatePicker className="date-range" name="DateBeg" format="DD.MM.YYYY" allowClear={false} value={filter.DateBeg} onChange={(val) => onFilterChange({ DateBeg: val })}/>
        <DatePicker className="date-range" name="DateEnd" format="DD.MM.YYYY" allowClear={false} value={filter.DateEnd} onChange={(val) => onFilterChange({ DateEnd: val })}/>
        <Button className="sport-btn" disabled={isNoneSelected || hasInvalidProductVid} onClick={() => setActivateModalVisible(true)}>Активировать</Button>
        <Button className="sport-btn" disabled={isNoneSelected || hasInvalidProductVid} onClick={() => setFreezeModalVisible(true)}>Заморозить</Button>
        <Button className="sport-btn" disabled={isNoneSelected || hasInvalidProductVid} onClick={() => setCloseModalVisible(true)}>Закрыть</Button>
        <Button onClick={getData} style={{ width:"56px", padding:"0px"}}>
          <SportTooltip placement="bottom" title="Обновить страницу">
            <HoverIcon src="/images/refresh.svg" hoverSrc="/images/refresh-white.svg" style={{width: 30}} alt="refresh"/>
          </SportTooltip>
        </Button>
        <Col><BtnSettingsTable name={tableName} columns={columns} onSettingsChange={onTableSettingsChange} defaultHiddenColumns={defaultHidden}/></Col>
        <HelpButton article="prodazhi"/>
      </div>

      <div className="sales-filter-container">
        {filters.length === 0 && !addingFilter && (
          <AddFilter
            availableFilters={filterOptions}
            usedFilters={filters.map(f => f.type)}
            onAdd={handleAddTopFilter}
          />
        )}

        {filters.map((f) => renderFilterItem(f.type, f))}

        {filters.length < filterOptions.length && (
          addingFilter ? (
            <AddFilter
              availableFilters={filterOptions}
              usedFilters={filters.map(f => f.type)}
              onAdd={handleAddTopFilter}
            />
          ) : (
            filters.length !== 0 && (
              <Button
                onClick={() => setAddingFilter(true)}
                type="dashed"
                className="filter-add-button"
              >
                +
              </Button>
            )
          )
        )}
      </div>

      <div className="sales-filter-div">
        <Col span={2}>
          <Button className="sport-btn" onClick={checkAll} disabled={isAllSelected || items.length === 0}>Выделить все</Button>
        </Col>
        <Col span={2}>
          <Button className="sport-btn" onClick={uncheckAll} disabled={isNoneSelected}>Снять выделение</Button>
        </Col>
        <Col span={2}>
          <Button style={{ width:"56px", padding:"0px"}} onClick={handleClient} disabled={!(selected.length == 1)}>
            <SportTooltip placement="bottom" title="Посмотреть клиента">  
              <HoverIcon src="/images/person_green.svg" hoverSrc="/images/person_white.svg" style={{width: 30}} alt="client"/>
            </SportTooltip>
          </Button>
        </Col>
        <Col span={2}>
          <Checkbox name="newClient" checked={filter.newClient} style={{marginTop:"6px"}} onChange={e => onFilterChange({ newClient: e.target.checked })}>Новые</Checkbox>
        </Col>
        <Col span={2}>
          <Checkbox name="deleted" checked={filter.deleted} style={{marginTop:"6px"}} onChange={e => onFilterChange({ deleted: e.target.checked })}>Удаленные</Checkbox>
        </Col>
        <Col span={3}>
          <Checkbox name="blocked" checked={filter.blocked} style={{marginTop:"6px"}} onChange={e => onFilterChange({ blocked: e.target.checked })}>Заблокированые</Checkbox>
        </Col>
        <Col span={3} style={{marginTop:"4px"}}>
          <TriStateCheckbox value={filter.paid} onChange={(val) => onFilterChange({ paid: val })}>Оплачено</TriStateCheckbox>
        </Col>
        <Col span={3}>
          <PrintButton onClick={handlePrint} />
        </Col>
        <Col span={3}>
          <ExportExcelButton onClick={handleExportExcel} />
        </Col>
      </div>
      {/* <p style={{marginLeft:"24px", fontWeight:"bold"}}>Выбрано {selected.length} эл.</p> */}
      <div ref={divRef} style={{ width: tableWidth }} className="col1-col">
        <div className="print-area">
          <Table className="table-main" dataSource={filteredItems} loading={loading} columns={tblGetColumns(columns, tableName, defaultHidden )} size="small" pagination={false} rowKey="id" 
          scroll={isPrinting ? undefined : { y: tableHeight - 32 }} sticky={!isPrinting}
            onRow={(record) => ({
              onClick: () => handleRowClick(record),
            })}
            summary={(pageData) => {
              const allCols = tblGetColumns(columns, tableName, defaultHidden);

              const flatten = (cols) => {
                const res = [];
                cols.forEach(c => {
                  if (c.children && c.children.length) {
                    res.push(...flatten(c.children));
                  } else {
                    res.push(c);
                  }
                });
                return res;
              };

              const visibleCols = flatten(allCols).filter(c => c.hidden !== true);

              const totals = {
                syma: pageData.reduce((s, r) => s + (Number(r.syma) || 0), 0),
                price: pageData.reduce((s, r) => s + (Number(r.price) || 0), 0),
                debet: pageData.reduce((s, r) => s + (Number(r.debet) || 0), 0),
                paid: pageData.reduce((s, r) => s + (Number(r.paid) || 0), 0),
                totalCalc: pageData.reduce((s, r) => s + ((Number(r.qty) || 0) * (Number(r.price) || 0)), 0),
              };

              return (
                <Table.Summary fixed>
                  <Table.Summary.Row>
                    {visibleCols.map((col, idx) => {
                      const key = col.key ?? col.dataIndex ?? String(idx);
                      const dataIndex = col.dataIndex;
                      let content = null;

                      if (idx === 0) {
                        content = <div style={{ fontSize:"12px", textWrap:"nowrap" }}><b>Итого: {pageData.length}</b></div>;
                      } else if (dataIndex === "syma") {
                        content = <div style={{ textAlign: "right", fontSize:"12px", padding:"0px" }}><b>{totals.syma.toFixed(2)}</b></div>;
                      } else if (dataIndex === "debet") {
                        content = <div style={{ textAlign: "right", fontSize:"12px", padding:"0px" }}><b>{totals.debet.toFixed(2)}</b></div>;
                      } else if (dataIndex === "totalCalc") {
                        content = <div style={{ textAlign: "right", fontSize:"12px", padding:"0px" }}><b>{totals.totalCalc.toFixed(2)}</b></div>;
                      } else if (dataIndex === "paid") {
                        content = <div style={{ textAlign: "right", fontSize:"12px", padding:"0px" }}><b>{totals.paid.toFixed(2)}</b></div>;
                      }

                      const align = col.align ?? (["syma","debet","totalCalc","paid"].includes(dataIndex) ? "right" : "left");

                      return (
                        <Table.Summary.Cell index={idx} key={key} align={align}>
                          {content}
                        </Table.Summary.Cell>
                      );
                    })}
                  </Table.Summary.Row>
                </Table.Summary>
              );
            }}
          />
        </div>
      </div>
      {freezeModalVisible && <FreezeModal onClose={onClose} saleId={selected}/>}
      {activateModalVisible && <ActivateModal onClose={onClose} saleId={selected}/>}
      {closeModalVisible && <CloseModal onClose={onClose} saleId={selected}/>}
      {modalVisible && <ResultModal onClose={resClose} results={modalResults}/>}
      {changeModalVisible && <Sale onClose={handleChangeModalClose} id={selected[0]}/>}
      {isClientCard && <Client id={recorded.clientId} onClose={onCloseEdit} />}
    </div>
  ) : 
  (<>
    <div style={{ fontWeight: 600, fontSize: 16, margin: 8, marginBottom: 6 }}>Продажи</div>
    <div className='selector-filer-section' style={{ marginTop: 0, marginBottom: 0 }}>
      <Input placeholder="Поиск" value={filter.searchText} onChange={(e) => onFilterChange({ searchText: e.target.value })} allowClear className="search-str"/>
      <img src="/images/filter.svg" className="mobile-top-img" alt="filter" onClick={() => setShowFilter(true)}/>
    </div>

    {loading ? ( <Spin />) : 
    (
      <>
        <div style={{display:"flex", justifyContent: "space-around", alignItems:"center", gap: "8px", marginRight:"6px", marginLeft: "6px"}}>
          <Text style={{minWidth: "80px"}}> Вид даты </Text>
          <Select label="Вид даты" options={dateFilterOptions} defaultValue={0} value={filter.DateVid}className="sale-date-filter-select" onChange={e => onFilterChange({ DateVid: e })}/>
        </div>
        <div className="sales-filter-date-line">
          <Text style={{minWidth: "80px"}}> Период с </Text>
          <DatePicker value={filter.DateBeg} format="DD.MM.YYYY" onChange={e => onFilterChange({ DateBeg: e })} allowClear={false}/>
          <Text style={{minWidth: "40px", textAlign: "center"}}> по </Text>
          <DatePicker value={filter.DateEnd} format="DD.MM.YYYY" onChange={e => onFilterChange({ DateEnd: e })} allowClear={false}/>
        </div>
        <div className="sales-buttons-line-triple-halfed">
          <Button disabled={isNoneSelected || hasInvalidProductVid} onClick={() => setActivateModalVisible(true)}>Активир.</Button>
          <Button disabled={isNoneSelected || hasInvalidProductVid} onClick={() => setFreezeModalVisible(true)}>Замороз.</Button>
          <Button disabled={isNoneSelected || hasInvalidProductVid} onClick={() => setCloseModalVisible(true)}>Закрыть</Button>
        </div>
        <div className="sale-cards-list" style={{height: window.innerHeight - menuSize - 130, overflowY: "scroll", overflowX: "clip"}}>
          {filteredItems.map((item) => {
            const borderColor = getStatusColor(item.status, item);
            return (
              <Card
                key={item.id}
                className="client-item-abon-card"
                style={{ borderLeft: `4px solid ${borderColor}` }}
                onClick={() => handleRowClick(item)}
              >
                <div className="sale-item-abon-card-name-debt-fields">
                  <div style={{display: "flex", alignItems: "center"}}>
                    <Checkbox name="selectedCard" 
                      checked={selected.includes(item.id)}
                      style={{marginRight:"6px"}} 
                      onChange={(e) => {
                        e.stopPropagation();
                        setSelected(prev => {
                          const next = e.target.checked ? [...prev, item.id] : prev.filter(x => x !== item.id);

                          if (next.length === 1) {
                            const rec = items.find(x => x.id === next[0]);
                            setRecorded(rec);
                          }

                          return next;
                        });
                      }}
                      onClick={(e) => e.stopPropagation()}
                    ></Checkbox>
                    <Text strong className="sales-product-name">{item.productName}</Text>
                  </div>
                  <Text strong>Долг: {item.debet}</Text>
                </div>

                <div className="client-item-abon-card-sum-sale-num-fields">
                  <Text># {item.id}</Text>
                  <Text>Сумма: {item.syma}</Text>
                  <Text>Продажа: {fmtDate(item.docDate)}</Text>
                </div>
                <Text>Клиент: {item.clientName}</Text>
              </Card>
            );
          })}
          {filteredItems.length == 0 ? 
            <div style={{ display: "flex", justifyContent: "center", width: "100%", marginBottom: "12px" }}>
              <Text>Нет данных</Text>
            </div> : <></>}
        </div>
      </>
    )}
    {freezeModalVisible && <FreezeModal onClose={onClose} saleId={selected}/>}
    {activateModalVisible && <ActivateModal onClose={onClose} saleId={selected}/>}
    {closeModalVisible && <CloseModal onClose={onClose} saleId={selected}/>}
    {modalVisible && <ResultModal onClose={resClose} results={modalResults}/>}
    {changeModalVisible && <Sale onClose={handleChangeModalClose} id={selected[0]}/>}
    {isClientCard && <Client id={recorded.clientId} onClose={onCloseEdit} />}
    {showFilter && <SalesFilter current={filter} filterOptions={filterOptions} filterLabels={filterLabels} userOptions={userOptions} onClose={(newFilter) => {
        setShowFilter(false);
        if (newFilter) { setFilter(newFilter); }
      }}
    
    />}
  </>);
};

export default Sales;
